// src/pages/import/declaracoes-aduaneiras/relatorios/relatorioControleDA.helpers.ts
import axios from 'axios';

const baseUrl =
  process.env.REACT_APP_QCX_API_BASE_URL! + '/followup/report/controle-da';

export const downloadRelatorioControleDA = async (
  token: string,
  unidadeId: number,               
  tenantIds: string[],               
  clientesIds: string[],             
  processosIds: string[],            
  inicio: string,                    
  fim: string                        
): Promise<void | { error: boolean; message: string }> => {
  const params = new URLSearchParams();
  params.set('tenantId', tenantIds.join(','));
  if (clientesIds?.length) params.set('clientesId', clientesIds.join(','));
  if (processosIds?.length) params.set('processosIds', processosIds.join(','));
  if (inicio) params.set('inicio', inicio);
  if (fim) params.set('fim', fim);

  try {
    const res = await axios.get(`${baseUrl}?${params.toString()}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        quickcomexTenant: unidadeId,
      },
      responseType: 'blob',
    });

    if (res.status === 200) {
      const file = new File([res.data], 'RelatorioControleDA.xlsx', {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = window.URL.createObjectURL(file);
      const a = document.createElement('a');
      a.href = url;
      a.download = file.name;
      a.click();
    } else {
      return { error: true, message: await res.data };
    }
  } catch (err: any) {
    if (axios.isAxiosError(err)) {
      if (err.response?.status === 404) {
        return { error: true, message: 'Nenhum resultado para os filtros.' };
      }
      if (err.response) {
        try {
          const msg = await err.response.data.text();
          return { error: true, message: msg };
        } catch {
          return { error: true, message: 'Erro ao ler resposta do servidor.' };
        }
      }
    }
    return { error: true, message: 'Erro inesperado.' };
  }
};
